import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Toolbar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ToolbarTitle" }, "Bodies", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Create new")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_button, {
        class: "ToolbarActions ChampionButton CreateNew",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toCreateBody()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.bodies,
      border: "",
      stripe: "",
      class: "FullWidth",
      "default-sort": _ctx.sorting
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "formattedId",
          label: "Body ID",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name"
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "Type"
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data", "default-sort"])
  ], 64 /* STABLE_FRAGMENT */))
}